module.exports = "/assets/data/82533e18a43e5890b324fc19ab00ff5b-EH20.data.json";